// extracted by css-extract-rspack-plugin
export default {"togglerWrapper":"toggler-wrapper--xzf4QbkRackpy2SW","togglerButton":"toggler-button--jX4Rcd6dmUovgsz_","togglerButtonActive":"toggler-button_active--zDxoC2Rtdod5cRyV"};